export const SOFTLINE_API_FILE = '/v2/file/{{key}}';
